import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstagram = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3153 8.27124H12.5067C10.597 8.27124 9.04858 9.81918 9.04858 11.7294V19.5377C9.04858 21.4477 10.597 22.9959 12.5067 22.9959H20.3151C22.2251 22.9959 23.7735 21.4477 23.7735 19.5377V11.7294C23.7735 9.81918 22.2251 8.27124 20.3151 8.27124H20.3153ZM16.4111 20.3168C13.8247 20.3168 11.7279 18.22 11.7279 15.6336C11.7279 13.0471 13.8247 10.9504 16.4111 10.9504C18.9976 10.9504 21.0944 13.0469 21.0944 15.6336C21.0944 18.2202 18.9976 20.3168 16.4111 20.3168V20.3168ZM21.2722 11.3438C20.8163 11.3438 20.4465 10.9742 20.4465 10.518C20.4465 10.0619 20.816 9.69229 21.2722 9.69229C21.7283 9.69229 22.0979 10.0619 22.0979 10.518C22.0979 10.9742 21.7283 11.3438 21.2722 11.3438Z",
			fill: "#EDFEF6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4109 12.5981C14.7341 12.5981 13.3751 13.9572 13.3751 15.6336C13.3751 17.3101 14.7344 18.6696 16.4109 18.6696C18.0873 18.6696 19.4466 17.3104 19.4466 15.6336C19.4466 13.9569 18.0876 12.5981 16.4109 12.5981V12.5981Z",
			fill: "#EDFEF6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4111 0C7.80156 0 0.822266 6.97929 0.822266 15.5888C0.822266 24.1984 7.80156 31.1777 16.4111 31.1777C25.0207 31.1777 31.9999 24.1984 31.9999 15.5888C31.9999 6.97929 25.0204 0 16.4111 0ZM25.4358 19.4036C25.4358 22.2811 23.1031 24.6133 20.2261 24.6133H12.5961C9.71885 24.6133 7.38645 22.2811 7.38645 19.4036V11.7738C7.38645 8.89659 9.71885 6.56418 12.5961 6.56418H20.2261C23.1034 6.56418 25.4358 8.89659 25.4358 11.7738V19.4039V19.4036Z",
			fill: "#EDFEF6"
		})
	]
});
export { SvgInstagram as ReactComponent };
